import { Cookies } from 'react-cookie';

const cookieProvider = new Cookies();

let user = cookieProvider.get('currentPatientAccount') || '';

export const initialState = {
	user: "" || user,
	loading: false,
	orgData: {
		organizationAvatarUrl: null,
		organizationName: '',
		officePhone: ''
	}
};

export const AuthReducer = (state, action) => {
	switch (action.type) {
		case "LOGIN_SUCCESS":
			return {
				...state,
				user: cookieProvider.get('currentPatientAccount'),
				loading: false
			};
		case "LOGOUT":
			return {
				...state,
				user: "",
				orgData: {
					organizationAvatarUrl: null,
					organizationName: '',
					officePhone: ''
				},
				hasScheduledCall: false
			};

		case "CONTACT_UPDATE":
			return {
				...state,
				user: action.payload
			};
		case "HAS_SCHEDULED_CALL":
			return {
				...state,
				hasScheduledCall: action.payload
			}
		case "SET_ORG_DATA":
			return {
				...state,
				orgData: action.payload
			}
		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};